export function formatTs(ts) {
  if (!ts) return '';
  const date = new Date(ts * 1000);
  return date.toISOString().split('T')[0];
}

export function shorten(str) {
  if (str.length < 10) return str;
  return `${str.slice(0, 6)}...${str.slice(str.length - 4)}`;
}
